/**
 * Global behavior for BCH theme.
 */

(function ($, Drupal, window/* , document */) {

    /**
     * Control scroll to bottom button visibility.
     */
    function toggleScrollToTopButton () {
      const verticalOffset = window.scrollY;
      const scrollToTopButton = document.getElementsByClassName('scroll-to-top')[0];
      console.log('scrollToTopButton', scrollToTopButton);

      if (verticalOffset < 100) {
        scrollToTopButton.classList.add('scroll-to-top--hidden');
        var privacyCenter = document.getElementById("privacy-center");
        if(privacyCenter) {
          injectPositionCss()
        }
      } else {
        scrollToTopButton.classList.remove('scroll-to-top--hidden');
      }
    }

    /**
     * Injects a class to an element.
     */
    function injectPositionCss() {
      var scrollToTop = document.getElementById("scroll-to-top");
      scrollToTop.classList.add('scroll-to-top--push-button-position');
    }

    /**
     * Removes a class from an element.
     */
    function removePositionCss() {
        var scrollToTop = document.getElementById("scroll-to-top");
        scrollToTop.classList.remove('scroll-to-top--push-button-position');
      }

  /**
   * Scroll to top
   */
  Drupal.behaviors.scrollToTop = {
    attach (context) {
      // Starting from here, only act on initial page load.
      if (context !== document) {
        return;
      }

      const $scrollToTopButton = $('.scroll-to-top', context);

      $scrollToTopButton.on('click', () => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      });

      document.addEventListener('scroll', toggleScrollToTopButton);
    },
  };

  Drupal.behaviors.adjustScrollToTopPosition = {
    attach(context) {
      $(document).ready(function () {
        var privacyCenter = document.getElementById("privacy-center");
        if (privacyCenter !== null) {
          injectPositionCss();
        }

        var acceptPolicy = document.getElementById('accept-privacy-policy');
        var scrollToTop = document.getElementById("scroll-to-top");
        var rejectPolicy = document.getElementById('decline-privacy-policy');

        if (rejectPolicy) {
          rejectPolicy.addEventListener('click', function() {
            if (scrollToTop) {
              scrollToTop.classList.remove('scroll-to-top--push-button-position');
            }
          });
        }

        if (acceptPolicy) {
          acceptPolicy.addEventListener('click', function() {
            if (scrollToTop) {
              scrollToTop.classList.remove('scroll-to-top--push-button-position');
            }
          });
        }
      });

      // Starting from here, only act on initial page load.
      if (context !== document) {
        return;
      }

      document.addEventListener('scroll', toggleScrollToTopButton);

      // Create a MutationObserver to watch for the #genesys-messenger element
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            // Check if #genesys-messenger is in the DOM
            var genesysMessenger = document.getElementById('genesys-messenger');
            if (genesysMessenger !== null) {
              // Apply class to adjust the position
              document.querySelector('.scroll-to-top').classList.add('genesys-messenger-active');
              observer.disconnect();
            }
          }
        });
      });

      // Set up the observer to look for child node changes in the body
      observer.observe(document.body, { childList: true, subtree: true });
    },
  };

  Drupal.behaviors.hideAlertBar = {
    attach (context) {
      // Starting from here, only act on initial page load.
      if (context !== document) {
        return;
      }

      once('alertBar', '.alert-bar', context).forEach((element) => {
        const $element = $(element);
        const $hideAlertBar = $element.find('.alert-bar__close');
        const $alertBarWrapper = $element.parents('.alert-bar__wrapper')
        const $alertID = $alertBarWrapper.attr('id');

        if (localStorage.getItem('alert-id') !== $alertID) {
          $alertBarWrapper.removeClass('alert-bar__wrapper--hidden');
        }

        $hideAlertBar.on('click', () => {
          localStorage.setItem('alert-id', $alertID);
          $alertBarWrapper.remove();
        });
      });
    },
  };

}(jQuery, Drupal, window, document));
